module.exports = __webpack_public_path__ + "img/u30.ee781e9b.jpg";